import { useStore } from "@/system_modules/store";

export default function Validators() {

    const store = useStore();

    const isEmpty = (fieldName, fieldValue) => {
        const TR = store.getTranslation();
        return !fieldValue ? TR.validator_empty.replace('{field}', fieldName) : "";
    }

    const isNum = (fieldName, fieldValue) => {
        const TR = store.getTranslation();
        let isNum = /^\d+$/.test(fieldValue);
        return !isNum ? TR.validator_num.replace('{field}', fieldName) : "";
    }

    const minLength = (fieldName, fieldValue, min) => {
        const TR = store.getTranslation();
        return fieldValue.length < min ? TR.validator_minlength.replace('{field}', fieldName).replace('{min}', min) : "";
    }

    const isEmail = (fieldName, fieldValue) => {
        const TR = store.getTranslation();
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !re.test(fieldValue) ? TR.validator_email.replace('{field}', fieldName) : "";
    }

    return { isEmpty, isNum, minLength, isEmail }
}